export default {
	interviews: 'تقييم',

	headers: {
		interviewsName: 'نوع التقييم',
		interviewsDate: 'تاريخ التقييم',
		interviewsResult: 'نتيجة التقييم',
	},

	inputs: {
		interviewsName: 'نوع التقييم',
		interviewsDate: 'تاريخ التقييم',
	},

	add: 'إضافة تقييم',
};
